export enum PasswordStatus {
    VALID,
    INVALID_MATCHES_CURRENT = 1,
    INVALID_CONTAINS_PROFILE_INFO = 2,
    INVALID_MISSING_NUMBER_OR_SYMBOL = 4,
    INVALID_DISALLOWED_CHARACTERS = 8,
    INVALID_LENGTH = 16,
    INVALID_CASE = 32,
    INVALID_NOT_CONFIRMED = 64,
    INVALID_CURRENT_PASSWORD = 128,
    ERROR = 256,
}

export interface ISetPasswordProfile {
    userName: string;
    email: string;
    firstName: string;
    lastName: string;
}

export interface ISetPasswordResources {
    PasswordRequirements: string;
    ValLengthRequirement: string;
    ValCharacterRequirement: string;
    ValCaseRequirement: string;
    ValSymbolRequirement: string;
    ValNameRequirement: string;
    ValConfMatchingRequirement: string;
    ValNewCurrentMatchingRequirement?: string;
}

export interface IValidationChecklistProps {
    newPasswordStatus: PasswordStatus;
    isNewDirty: boolean;
    isConfirmDirty: boolean;
    isCurrentDirty?: boolean;
    passwordResources: ISetPasswordResources;
}
